export default {
  'menu.availability.title': '库存管理',

  'menu.availability.placeholder.serviceType': '请选择菜单',
  'menu.availability.placeholder.category': '请选择子菜单/分类，可多选',
  'menu.availability.placeholder.name': '搜索菜品名',

  'menu.availability.column.image': '图片',
  'menu.availability.column.name': '菜品名',
  'menu.availability.column.foreign_name': '菜品中文名',
  'menu.availability.column.category': '关联分类',
  'menu.availability.column.status': '状态',
  'menu.availability.column.createdAt': '创建时间',
  'menu.availability.column.quota': '库存',

  'menu.availability.selectedItems': '已选中 {count} 项',

  'menu.availability.column.status.soldOut': '已售罄',
  'menu.availability.column.status.available': '可售',

  'menu.availability.soldOutItems.title': '售罄菜品  {count} 项',
  'menu.availability.availableItems.title': '可售菜品  {count} 项',

  'menu.availability.action.markAsAvailable': '设为可售',
  'menu.availability.action.markAsSoldOut': '设为售罄',
  'menu.availability.action.editQuota': '编辑库存',
  'menu.availability.timeToBeAvailable': '商品会在{timeDesc}自动恢复为可售状态',

  'menu.availability.markAsAvailable.title': '确认要将选中的菜品设为可售吗？确认后这些菜品将会立即出现在您的菜单上',
  'menu.availability.markAsAvailable.success': '成功将选中的菜品标记为可售',
  'menu.availability.markAsAvailable.failed': '将选中的菜品标记为可售失败',
  'menu.availability.markAsSoldOut.success': '成功将选中的菜品标记为已售罄',
  'menu.availability.markAsSoldOut.failed': '将选中的菜品标记为已售罄失败',
  'menu.availability.quotaEditSuccess': '更新库存成功',

  'menu.availability.placeholder.searchCustomizations': '搜索菜品搭配选项',
  'menu.availability.soldOutOptions.title': '售罄选项',

  'menu.availability.customizations.mixedOptions': '请选择状态一致的菜品选项',

  'menu.availability.editDishQuota.title': '编辑菜品库存',
  'menu.availability.bulkEditDishQuota.title': '批量编辑菜品库存',
  'menu.availability.bulkEditDishQuota.content': '所有<b>{dishCount}个被选中菜品</b>库存将被更新',
  'menu.availability.customizations.editDishQuota.title': '编辑菜品搭配选项库存',

  'menu.transaction.report.title': '该报表只针对cost plus',
};
